import { render, staticRenderFns } from "./BVN.vue?vue&type=template&id=f95890dc"
import script from "./BVN.vue?vue&type=script&lang=js"
export * from "./BVN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports